import { initializePaddle } from '@paddle/paddle-js';

export async function initPaddle() {

  const environment =
    process.env.REACT_APP_PADDLE_SANDBOX === 'true' ? 'sandbox' : 'production';

  const instance = await initializePaddle({
    environment,
    token: process.env.REACT_APP_PADDLE_TOKEN,
    checkout: {
      settings: { theme: 'dark', allowLogout: false }
    },
    eventCallback(data) {
      if (data.name === 'checkout.completed') {
        window.dispatchEvent(
          new CustomEvent('PaddleCheckoutCompleted', { detail: data })
        );
      }
      if (data.name === 'checkout.closed') {
        window.dispatchEvent(
          new CustomEvent('PaddleCheckoutClosed', { detail: data })
        );
      }
      if (data.name === 'checkout.ready') {
        window.dispatchEvent(
          new CustomEvent('PaddleInlineCheckoutReady')
        );
      }
    }
  });

  window.Paddle = instance;
  return instance;
}
